"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Capital Service
 * Capital Service OpenAPI specifications
 *
 * The version of the OpenAPI document: 1.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessDataTotalEmployeesEnum = exports.BusinessDataIndustryEnum = exports.BusinessDataTypeEnum = void 0;
exports.BusinessDataTypeEnum = {
    Pt: 'PT',
    Cv: 'CV',
    Individual: 'INDIVIDUAL'
};
exports.BusinessDataIndustryEnum = {
    O1: 'O1',
    O2: 'O2',
    O3: 'O3',
    O4: 'O4',
    O5: 'O5',
    O6: 'O6',
    O7: 'O7',
    O8: 'O8',
    O9: 'O9',
    O10: 'O10',
    O11: 'O11',
    O12: 'O12',
    O13: 'O13',
    O14: 'O14',
    O15: 'O15',
    O16: 'O16',
    O17: 'O17',
    O18: 'O18',
    O19: 'O19',
    O20: 'O20',
    O21: 'O21',
    O22: 'O22',
    O23: 'O23',
    O24: 'O24',
    O25: 'O25',
    O26: 'O26',
    O27: 'O27',
    O28: 'O28',
    O29: 'O29',
    O30: 'O30',
    O31: 'O31',
    O32: 'O32',
    O33: 'O33',
    O34: 'O34',
    O35: 'O35',
    O36: 'O36',
    O37: 'O37',
    O38: 'O38',
    O39: 'O39',
    O40: 'O40',
    O41: 'O41',
    O42: 'O42',
    O43: 'O43',
    O44: 'O44',
    O45: 'O45',
    O46: 'O46',
    O47: 'O47'
};
exports.BusinessDataTotalEmployeesEnum = {
    B150: 'B1_50',
    B51100: 'B51_100',
    B101250: 'B101_250',
    B251500: 'B251_500',
    B5011000: 'B501_1000',
    O1000: 'O1000'
};
